import React from 'react'
import PropTypes from 'prop-types'
import muiThemeable from 'material-ui/styles/muiThemeable'

const WraaperTabC = muiThemeable()(
  ({
    muiTheme: {
      palette: {
        borderColor,
      },
    },
    children,
  }) => (
    <div
      style={{
        borderBottom: `1px solid ${borderColor}`,
        display: 'flex',
        backgroundColor: '#f5f5f5',
        paddingLeft: 15,
        cursor: 'pointer',
      }}
    >
      {children}
    </div>
  ),
)

WraaperTabC.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.object)]).isRequired,
}

export default WraaperTabC



// WEBPACK FOOTER //
// ./src/components/Tabs/WrapperTabs/WrapperTabC.js